<template>
  <div class="page-header">
    <!-- 顶部通栏 -->
    <div class="text-wrapper_1 flex-col">
      <span class="text_1" @click="openSamrUrl" style="cursor: pointer;">国家市场监督管理总局&nbsp;主管</span>
    </div>
    <!-- 品牌栏 -->
    <div class="box_2 flex-row">
      <img class="image_1" referrerpolicy="no-referrer" :src="require('../assets/img/FigmaDDSSlicePNGe1c2884bb137e0987da286949c5029de.png')" @click="goHome" style="cursor:pointer" />
      <span class="text_2">让品牌动力中国</span>
      <div class="block_2 flex-row">
        <input class="search-input" type="text" placeholder="请输入搜索内容" v-model="searchText" @keyup.enter="onSearch" />
        <div class="image-wrapper_1 flex-col" @click="onSearch" style="cursor:pointer">
          <img class="label_1" referrerpolicy="no-referrer" :src="require('../assets/img/FigmaDDSSlicePNGe484cf7ce4ae3d2890837c7651d63ec1.png')" />
        </div>
      </div>
    
        <img class="qr-icon" referrerpolicy="no-referrer" :src="require('../assets/img/erweima.png')" @mouseenter="showQrCode = true" @mouseleave="showQrCode = false" />
        <!-- 公众号二维码弹层 - 定位在按钮正下方 -->
          <div v-if="showQrCode"  class="qr-popup"  style="margin-top: -50px;margin-left: 22px;">
            <div class="qr-popup-card">
              <!-- 向上小箭头 -->
              <span class="qr-popup-arrow"></span>
              <!-- 二维码主体 -->
              <div class="qr-popup-body">
                <img :src="wxQrCodeUrl" :alt="wxQrCodeName" />
                <span class="qr-popup-desc">{{ wxQrCodeName }}</span>
              </div>
            </div>
          </div>
      <!-- 用户头像/图标：已登录显示头像，未登录显示默认图标 -->
      <div class="user-avatar-wrap" @click="goCenter" style="cursor:pointer;margin-top: -4px;">
        <img v-if="userAvatar" class="user-avatar-img" :src="userAvatar" alt="用户头像" />
        <img v-else class="label_2" referrerpolicy="no-referrer" :src="require('../assets/img/FigmaDDSSlicePNG4eedcbfd5e10232e472a00126889ff55.png')" style="margin-top: -1px;" />
      </div>
      <img class="label_3" referrerpolicy="no-referrer" :src="require('../assets/img/FigmaDDSSlicePNGdd1cbdf006a7c51b8301a68adc7ae39b.png')" @mouseenter="showMobileQrCode = true" @mouseleave="showMobileQrCode = false" />
      <!-- 公众号二维码弹层 - 定位在按钮正下方 -->
      
          <div v-if="showMobileQrCode"  style="margin-top: -50px;margin-right: 22px;" class="qr-popup">
            <div class="qr-popup-card">
              <!-- 向上小箭头 -->
              <span class="qr-popup-arrow"></span>
              <!-- 二维码主体 -->
              <div class="qr-popup-body">
                <img :src="MobileQrCodeUrl" :alt="MobileQrCodeName" />
                <span class="qr-popup-desc">{{ MobileQrCodeName }}</span>
              </div>
            </div>
          </div>
      
      <img class="label_4" referrerpolicy="no-referrer" :src="require('../assets/img/FigmaDDSSlicePNG8c769677dc67bc14ff44684e7629456d.png')" @click="goSiteNavigation" style="cursor:pointer" />
    </div>

    <!-- 导航栏 -->
    <div class="box_7 flex-row">
      <span
        v-for="(item, index) in categories"
        :key="index"
        :class="['nav-item', { 'nav-active': activeCategoryId === item.id }]"
        @click="goCategory(item)"
      >{{ item.name }}</span>
    </div>

    <!-- 全局登录弹窗 -->
    <div v-if="showLoginDialog" class="login-modal-mask">
      <div class="login-modal-container">
        <LoginCard :visible="true" :modal-mode="true" @close="closeLoginDialog" @login-success="handleLoginSuccess" />
      </div>
    </div>
  </div>
</template>

<script>
import request from '../api/request'
import LoginCard from '../../login/LoginCard.vue'

export default {
  name: 'PageHeader',
  components: {
    LoginCard
  },
  props: {
    categoryId: {
      type: [Number, String],
      default: null
    }
  },
  data() {
    return {
      categories: [],
      activeCategoryId: null,
      // 如果页面参数中有 query，回填到搜索框
      searchText: this.$route.query.query || '',
      // 公众号二维码弹层显示状态
      showQrCode: false,
      // 手机端浏览二维码弹层显示状态
      showMobileQrCode: false,
      // 登录弹窗相关
      showLoginDialog: false,
      redirectPath: null,
      // 用户头像
      userAvatar: '',
      wxQrCodeUrl: require('../assets/img/gongzhonghao.png'),
      wxQrCodeName: '微信公众号',
      MobileQrCodeUrl: require('../assets/img/mobile.png'),
      MobileQrCodeName: '手机端浏览'
    }
  },
  watch: {
    // 监听路由参数变化，保持搜索框内容同步
    '$route.query.query'(val) {
      this.searchText = val || ''
    },
    '$route'() {
      this.updateActiveCategoryId()
    },
    categoryId() {
      this.updateActiveCategoryId()
    }
  },
  created() {
    this.updateActiveCategoryId()
    this.loadCategories()
    this.loadUserAvatar()
    this.loadQrCode()
  },
  mounted() {
    // 监听全局登录事件
    console.log('[PageHeader] mounting, adding login-required listener')
    window.addEventListener('login-required', this.handleLoginRequired)
    // 监听用户信息更新事件，刷新头像
    window.addEventListener('refresh-user-info', this.loadUserAvatar)
  },
  beforeUnmount() {
    console.log('[PageHeader] unmounting, removing login-required listener')
    window.removeEventListener('login-required', this.handleLoginRequired)
    window.removeEventListener('refresh-user-info', this.loadUserAvatar)
  },
  methods: {
    // 加载用户头像
    loadUserAvatar() {
      const token = localStorage.getItem('token')
      if (!token) {
        this.userAvatar = ''
        return
      }
      try {
        const userInfoStr = localStorage.getItem('userInfo')
        if (userInfoStr) {
          const userInfo = JSON.parse(userInfoStr)
          this.userAvatar = userInfo.avatar || ''
        } else {
          this.userAvatar = ''
        }
      } catch (e) {
        this.userAvatar = ''
      }
    },
    onSearch() {
      const q = this.searchText.trim()
      if (!q) return
      this.$router.push(`/search?query=${encodeURIComponent(q)}`)
    },
    updateActiveCategoryId() {
      const categoryId = this.categoryId || this.$route.query.categoryId
      if (categoryId) {
        this.activeCategoryId = Number(categoryId)
        return
      }
      if (this.$route.path === '/') {
        this.activeCategoryId = 0
        return
      }
      if (this.$route.path === '/magazine') {
        const magazine = this.categories.find(item => item.name === '电子杂志')
        if (magazine) {
          this.activeCategoryId = magazine.id
          return
        }
      }
      this.activeCategoryId = null
    },
    async loadCategories() {
      try {
        const res = await request.post('/api/index/getCategory')
        const list = res.data || []
        this.categories = [
          { id: 0, name: '首页', categoryTemplatePath: '/', color: null },
          ...list.sort((a, b) => (a.sortOrder || 0) - (b.sortOrder || 0))
        ]
        this.updateActiveCategoryId()
      } catch (err) {
        // 接口失败保持空导航
      }
    },
     async loadQrCode() {
      try {
        const res = await request.post('/api/index/getQrcodeList')
        if (res.code === 200 && res.data) {
          for (const item of res.data) {
            if(item.id === 1)
          {
            this.wxQrCodeUrl = item.qrcodeImage
            this.wxQrCodeName = item.name
          }
          if(item.id === 2)
          {
            this.MobileQrCodeUrl = item.qrcodeImage
            this.MobileQrCodeName = item.name
          }
          }
          
        }
      } catch (err) {
        // 接口失败保持空导航
      }
    },
    goCategory(item) {
      if (item.name === '电子杂志') {
        this.$router.push('/magazine')
        return
      }
      if (!item.categoryTemplatePath) return
      const path = item.id === 0 ? '/' : `${item.categoryTemplatePath}?categoryId=${item.id}`
      window.location.href = path
    },
    openSamrUrl() {
      window.open('https://www.samr.gov.cn/', '_blank')
    },
    goHome() {
      this.$router.push('/')
    },
    // 点击用户图标：根据登录态和 userType 跳转对应中心
    goCenter() {
      const token = localStorage.getItem('token')
      const userType = localStorage.getItem('userType')
      if (!token) {
        const currentPath = this.$route.fullPath
        this.$router.push({ path: '/login', query: { redirect: currentPath } })
        return
      }
      if (userType === 'company') {
        this.$router.push('/my')
      } else {
        this.$router.push('/my')
      }
    },
    // 跳转全站导航页面
    goSiteNavigation() {
      this.$router.push('/site-navigation')
    },
    handleLoginRequired(event) {
      console.log('[PageHeader] received login-required event:', event.detail)
      this.showLoginDialog = true
      console.log('[PageHeader] showLoginDialog set to:', this.showLoginDialog)
    },
    closeLoginDialog() {
      console.log('[PageHeader] closing login dialog')
      this.showLoginDialog = false
      this.redirectPath = null
    },
    handleLoginSuccess() {
      console.log('[PageHeader] login success, refreshing user info')
      this.closeLoginDialog()
      // 登录成功后跳转回原始页面
      if (this.redirectPath) {
        window.location.href = this.redirectPath
      }
      // 通过事件通知 PageMain 刷新用户信息
      const refreshUserEvent = new CustomEvent('refresh-user-info')
      window.dispatchEvent(refreshUserEvent)
    },
  }
}
</script>

<style scoped>
/* ===== 顶部通栏 ===== */
.text-wrapper_1 {
  background-color: rgba(125, 0, 0, 1);
  height: 50px;
  width: 1400px;
  position: relative;
}
.text-wrapper_1::before,
.text-wrapper_1::after {
  content: '';
  position: absolute;
  top: 0;
  bottom: 0;
  width: calc((var(--viewport-width) - 1400px) / 2);
  background-color: rgba(125, 0, 0, 1);
}
.text-wrapper_1::before {
  right: 100%;
}
.text-wrapper_1::after {
  left: 100%;
}
.text_1 {
  width: 222px;
  height: 30px;
  overflow-wrap: break-word;
  color: rgba(252, 224, 187, 1);
  font-size: 18px;
  font-family: Microsoft YaHei-Regular;
  text-align: left;
  white-space: nowrap;
  line-height: 30px;
  margin-top: 10px;
}

/* ===== 品牌栏 ===== */
.box_2 {
  background-color: rgba(160, 0, 0, 1);
  width: 1400px;
  height: 130px;
  position: relative;
}
.box_2::before,
.box_2::after {
  content: '';
  position: absolute;
  top: 0;
  bottom: 0;
  width: calc((var(--viewport-width) - 1400px) / 2);
  background-color: rgba(160, 0, 0, 1);
}
.box_2::before {
  right: 100%;
}
.box_2::after {
  left: 100%;
}
.image_1 {
  width: 147px;
  height: 58px;
  margin: 34px 0 0 2px;
}
.text_2 {
  width: 214px;
  height: 30px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 24px;
  letter-spacing: 2.057142972946167px;
  font-family: Microsoft YaHei UI-Regular;
  text-align: left;
  white-space: nowrap;
  line-height: 24px;
  margin: 48px 0 0 38px;
}
.block_2 {
  background-color: rgba(255, 255, 255, 0.9);
  border-radius: 34px;
  height: 56px;
  width: 435px;
  margin: 35px 0 0 294px;
  display: flex;
  align-items: center;
  padding: 0 6px 0 20px;
  box-sizing: border-box;
}
.search-input {
  flex: 1 1 auto;
  width: 0;
  min-width: 0;
  border: none;
  outline: none;
  background: transparent;
  font-size: 16px;
  font-family: Microsoft YaHei-Regular;
  color: rgba(51, 51, 51, 1);
  flex-shrink: 1 !important;
}
.search-input::placeholder {
  color: rgba(180, 180, 180, 1);
}
.image-wrapper_1 {
  background-image: linear-gradient(180deg, rgba(232, 26, 26, 1) 0, rgba(166, 0, 0, 1) 100%);
  border-radius: 50%;
  height: 45px;
  width: 45px;
  flex-shrink: 0;
  margin: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
.label_1 {
  width: 24px;
  height: 24px;
  margin: auto;
  display: block;
}
.qr-wrapper {
  position: relative;
  margin: 47px 0 0 33px;
}
.qr-icon {
  width: 32px;
  height: 32px;
  cursor: pointer;
  display: block;
}
/* ===== 二维码弹层 ===== */
.qr-popup {
  position: absolute;
  top: calc(100% + 10px);
  right: 0;
  z-index: 9999;
  margin-top: -50px;
  margin-right: 151px;
  overflow:visible;
}
.qr-popup-card {
  position: relative;
  background: rgba(255, 255, 255, 1);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  overflow: visible;
  width: 140px;
}
/* 向上小箭头 */
.qr-popup-arrow {
    content: '';
    position: absolute;
    bottom: calc(100% - 12px);
    left: 50%;
    transform: translateX(-50%) rotate(45deg);
    width: 20px;
    height: 20px;
    background: #ffffff;
    border-radius: 4px;
    box-shadow: -2px -2px 6px rgba(0, 0, 0, 0.05);
}
.qr-popup-body {
  padding: 14px 12px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.qr-popup-body img {
  width: 110px;
  height: 110px;
  border-radius: 4px;
}
.qr-popup-desc {
  margin-top: 10px;
  font-size: 12px;
  color: #999;
  line-height: 1.4;
}
.qr-fade-enter-active,
.qr-fade-leave-active {
  transition: all 0.3s ease;
}
.qr-fade-enter-from,
.qr-fade-leave-to {
  opacity: 0;
  transform: scale(0.85);
  transform-origin: top right;
}
.label_2 {
  width: 32px;
  height: 32px;
  margin: 47px 0 0 3px;
  cursor: pointer;
}

/* 用户头像容器 */
.user-avatar-wrap {
  margin: 47px 0 0 33px;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* 用户头像 */
.user-avatar-img {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  object-fit: cover;
  border: 2px solid rgba(255, 255, 255, 0.3);
  cursor: pointer;
  transition: opacity 0.2s ease;
}

.user-avatar-img:hover {
  opacity: 0.85;
}
.label_3 {
  width: 21px;
  height: 30px;
  margin: 48px 0 0 38px;
}
.label_4 {
  width: 30px;
  height: 30px;
  margin: 48px 5px 0 38px;
}

/* ===== 导航栏 ===== */
.box_7 {
  background-color: rgba(241, 241, 241, 1);
  width: 1400px;
  height: 80px;
  align-items: center;
  padding: 0 0px;
  position: relative;
}
.box_7::before,
.box_7::after {
  content: '';
  position: absolute;
  top: 0;
  bottom: 0;
  width: calc((var(--viewport-width) - 1400px) / 2);
  background-color: rgba(241, 241, 241, 1);
}
.box_7::before {
  right: 100%;
}
.box_7::after {
  left: 100%;
}
.nav-item {
  color: rgba(102, 102, 102, 1);
  font-size: 18px;
  font-family: Microsoft YaHei-Regular;
  text-align: center;
  white-space: nowrap;
  line-height: 16px;
  margin: 0 6px;
  cursor: pointer;
  padding: 7px 13px;
  border-radius: 100px;
  transition: color 0.2s ease, background-color 0.2s ease;
  flex-shrink: 1;
}
.nav-item:first-child {
  margin-left: 0;
}
.nav-item:hover {
  color: rgba(160, 0, 0, 1);
}
.nav-active {
  background-color: rgba(160, 0, 0, 1);
  color: rgba(255, 255, 255, 1) !important;
  flex-shrink: 0;
}

/* ========== 登录弹窗遮罩层 ========== */
.login-modal-mask {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
}

.login-modal-container {
  position: relative;
  animation: modal-fade-in 0.3s ease;
}

@keyframes modal-fade-in {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>
